import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import EnkryptBanner from "@/components/enkrypt-banner/index.vue";
import AccountsBalance from "./components/accounts-balance.vue";
import AccountsItem from "./components/accounts-item.vue";
import { accounts, nativeBalances, nativeToken } from "@/stores";
import { useGetNativeBalances } from "@/libs/balances";
import { computed, onMounted } from "vue";
import { useGetNativePrice } from "@/libs/prices";
import BigNumber from "bignumber.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => {
  useGetNativeBalances();
  useGetNativePrice();
});

const totalBalance = computed(() => {
  if (nativeBalances) {
    return Object.values(nativeBalances).reduce(
      (previous, current) => previous.plus(current?.total || 0),
      new BigNumber(0)
    );
  }

  return new BigNumber(0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EnkryptBanner),
    _createVNode(WhiteWrapper, null, {
      default: _withCtx(() => [
        _createVNode(AccountsBalance, {
          balance: totalBalance.value,
          token: _unref(nativeToken)
        }, null, 8, ["balance", "token"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accounts), (item, index) => {
          return (_openBlock(), _createBlock(AccountsItem, {
            key: index,
            account: item,
            balance: _unref(nativeBalances)[item.address],
            token: _unref(nativeToken),
            "is-last": index == _unref(accounts).length - 1
          }, null, 8, ["account", "balance", "token", "is-last"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})